import { observer } from 'mobx-react-lite'
import React from 'react'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import { UsersBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/UsersBlock'
import styles from './styles.module.scss'
import { type CallQueueStore } from '../../store/CallQueueStore'

type IActionEditContentProps = {
  store: CallQueueStore
}
export const CallQueueActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingMessageStore, greetingMusicStore, usersBlockStore, inboxMemberIds } = store

  return (
    <div className={styles.wrap}>
      <UsersBlockEditContent store={usersBlockStore} inboxMemberIds={inboxMemberIds} />
      <GreetingAudioBlockEditContent labelText={'Greeting message'} store={greetingMessageStore} />
      <GreetingAudioBlockEditContent labelText={'Greeting music'} store={greetingMusicStore} />
    </div>
  )
})
